module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "page-title"
  }, [_vm._v("Announcements from " + _vm._s(_vm.siteName))]), _vm._v(" "), _c('section', _vm._l((_vm.announcements), function(item) {
    return _c('div', {
      staticClass: "announcement-item"
    }, [_c('div', {
      staticClass: "posted-date"
    }, [_vm._v("Posted " + _vm._s(_vm.getFormatedDate(item.postedDate)))]), _vm._v(" "), _c('div', {
      staticClass: "title"
    }, [(item.titlePrefix) ? _c('span', [_vm._v(_vm._s(item.titlePrefix) + ": ")]) : _vm._e(), _vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "description"
    }, [_vm._v(_vm._s(item.description))]), _vm._v(" "), (item.url) ? _c('div', {}, [_c('a', {
      attrs: {
        "href": item.url
      }
    }, [_vm._v(_vm._s(item.url))])]) : _vm._e()])
  })), _vm._v(" "), _c('title-block', {
    attrs: {
      "title": "Trending Keywords",
      "link-title": "View All",
      "link-name": "",
      "color-theme": "primary-color"
    }
  }, [_c('div')]), _vm._v(" "), _c('title-block', {
    attrs: {
      "title": "Trending Popular Articles",
      "link-title": "View All",
      "link-name": "",
      "color-theme": "primary-color"
    }
  }, [_c('div', _vm._l((_vm.issues), function(issue, index) {
    return (index < 3) ? _c('condensed-issue', {
      key: issue.id,
      attrs: {
        "issue": issue
      }
    }) : _vm._e()
  }))]), _vm._v(" "), _c('title-block', {
    attrs: {
      "title": ("Top 5 " + _vm.siteName + " Papers Rated by Altmetric Attention Score"),
      "link-title": "View All",
      "link-name": "",
      "color-theme": "primary-color"
    }
  }, [_c('div', _vm._l((_vm.issues), function(issue, index) {
    return (index < 5) ? _c('condensed-issue', {
      key: issue.id,
      attrs: {
        "issue": issue
      }
    }) : _vm._e()
  }))]), _vm._v(" "), _c('title-block', {
    attrs: {
      "title": "Google Mention Alert",
      "color-theme": "primary-color"
    }
  }, [_c('div')]), _vm._v(" "), _c('title-block', {
    attrs: {
      "title": "Social Feeds",
      "color-theme": "primary-color"
    }
  }, [_c('div')])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2bb76eef"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/about/AnnouncementsPage.vue
// module id = 1413
// module chunks = 1